var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKLogoCathk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173.591,
    height: 195.366,
    viewBox: "0 0 173.591 195.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M166.125,72.52c-3.692,1.886-32.01,36.947-32.01,36.947s-24.274,29.358-22.752,33.227,53.878,44.265,56.351,45.663c2.292,1.3,36.985,7.04,42.631,7.052h.025c.428,0,.684-.035.738-.109.756-1.025-49.792-47.161-55.983-58.537s32.552-56.19,33.159-59.433c.487-2.6-11.723-5.346-18.46-5.345a9.153,9.153,0,0,0-3.7.535",
    transform: "translate(-111.294 -71.985)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M128.5,12.655C124.97,14.842,16.061,189.3,16.565,191.69s31.841-3.216,36.455-7.782S181.1,3.5,178.738,1.935a2.388,2.388,0,0,0-1.111-.163c-7.354,0-45.828,8.86-49.124,10.883",
    transform: "translate(-16.563 -1.772)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(-16.563 -1.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(90.332 73.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M215.986,193.242l-4.415,6.164h8.83Z",
    transform: "translate(-115.038 -76.513)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M208.8,198.39l4.055-5.66h-8.109Z",
    transform: "translate(-114.783 -76.494)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M201.586,193.242l-4.415,6.164H206Z",
    transform: "translate(-114.501 -76.513)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M194.4,198.39l4.055-5.66h-8.109Z",
    transform: "translate(-114.246 -76.494)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M182.77,199.406h8.83l-4.416-6.165Z",
    transform: "translate(-113.963 -76.513)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M194.425,184.125l-3.41,4.759h6.819Z",
    transform: "translate(-114.271 -76.173)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M198.216,182.676l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-114.54 -76.119)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M208.825,184.125l-3.41,4.759h6.819Z",
    transform: "translate(-114.809 -76.173)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M184.4,192.206h-8.83l4.415,6.164Z",
    transform: "translate(-113.694 -76.475)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M168.369,199.406H177.2l-4.416-6.164Z",
    transform: "translate(-113.425 -76.513)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M161.168,192.206l4.415,6.164L170,192.206Z",
    transform: "translate(-113.156 -76.475)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M158.384,193.242l-4.416,6.164h8.83Z",
    transform: "translate(-112.887 -76.513)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M151.2,198.39l4.055-5.66h-8.109Z",
    transform: "translate(-112.632 -76.494)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M139.567,199.406h8.83l-4.415-6.165Z",
    transform: "translate(-112.349 -76.513)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M140.851,192.729h-8.109l4.055,5.66Z",
    transform: "translate(-112.095 -76.494)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M125.167,199.406H134l-4.416-6.164Z",
    transform: "translate(-111.812 -76.513)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M122.4,198.39l4.055-5.66h-8.109Z",
    transform: "translate(-111.557 -76.494)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M122.42,184.125l-3.41,4.759h6.819Z",
    transform: "translate(-111.582 -76.173)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M133.03,182.676h-6.818l3.409,4.759Z",
    transform: "translate(-111.851 -76.119)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M137,184.371l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-112.12 -76.173)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M140.612,182.676l3.41,4.759,3.409-4.759Z",
    transform: "translate(-112.389 -76.119)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M151.222,184.125l-3.41,4.759h6.819Z",
    transform: "translate(-112.657 -76.173)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M155.014,182.676l3.409,4.759,3.41-4.759Z",
    transform: "translate(-112.926 -76.119)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M165.583,183.188l-4.415,6.165H170Z",
    transform: "translate(-113.156 -76.138)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M176.853,182.676h-8.11l4.056,5.661Z",
    transform: "translate(-113.439 -76.119)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M179.662,183.657l-4.093,5.714h8.186Z",
    transform: "translate(-113.694 -76.155)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M190.633,182.676h-6.819l3.409,4.759Z",
    transform: "translate(-114.002 -76.119)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M219.435,182.676h-6.819l3.409,4.759Z",
    transform: "translate(-115.077 -76.119)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M185.926,173.423l-4.415,6.164h8.83Z",
    transform: "translate(-113.916 -75.773)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M178.74,178.571l4.055-5.66h-8.109Z",
    transform: "translate(-113.661 -75.754)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M171.525,173.423l-4.415,6.164h8.829Z",
    transform: "translate(-113.378 -75.773)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M164.339,178.571l4.055-5.66h-8.109Z",
    transform: "translate(-113.123 -75.754)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M152.709,179.587h8.83l-4.416-6.165Z",
    transform: "translate(-112.84 -75.773)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M164.364,164.307l-3.41,4.759h6.819Z",
    transform: "translate(-113.148 -75.433)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M168.155,162.857l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-113.417 -75.379)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M178.765,164.307l-3.41,4.759h6.819Z",
    transform: "translate(-113.686 -75.433)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M197.2,172.91h-8.109l4.055,5.66Z",
    transform: "translate(-114.199 -75.754)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M154.34,172.387h-8.83l4.415,6.164Z",
    transform: "translate(-112.571 -75.734)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M138.308,179.587h8.831l-4.416-6.164Z",
    transform: "translate(-112.302 -75.773)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M131.108,172.387l4.415,6.164,4.416-6.164Z",
    transform: "translate(-112.034 -75.734)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M128.323,173.423l-4.416,6.164h8.83Z",
    transform: "translate(-111.765 -75.773)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M121.136,178.571l4.055-5.66h-8.109Z",
    transform: "translate(-111.51 -75.754)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M109.507,179.587h8.83l-4.415-6.165Z",
    transform: "translate(-111.227 -75.773)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M110.552,162.857l3.41,4.759,3.409-4.759Z",
    transform: "translate(-111.266 -75.379)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M121.161,164.307l-3.41,4.759h6.819Z",
    transform: "translate(-111.535 -75.433)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M124.953,162.857l3.409,4.759,3.41-4.759Z",
    transform: "translate(-111.804 -75.379)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M135.523,163.37l-4.415,6.165h8.83Z",
    transform: "translate(-112.034 -75.398)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M146.793,162.857h-8.11l4.056,5.661Z",
    transform: "translate(-112.316 -75.379)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M149.6,163.838l-4.093,5.714h8.186Z",
    transform: "translate(-112.571 -75.415)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M160.573,162.857h-6.819l3.409,4.759Z",
    transform: "translate(-112.879 -75.379)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M189.374,162.857h-6.819l3.409,4.759Z",
    transform: "translate(-113.955 -75.379)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M193.341,164.552l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-114.224 -75.433)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M207.081,153.6l-4.415,6.164h8.83Z",
    transform: "translate(-114.706 -75.033)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M199.895,158.749l4.055-5.66H195.84Z",
    transform: "translate(-114.451 -75.014)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M192.68,153.6l-4.415,6.164H197.1Z",
    transform: "translate(-114.168 -75.033)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M185.494,158.749l4.055-5.66h-8.109Z",
    transform: "translate(-113.913 -75.014)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M173.864,159.765h8.83l-4.416-6.165Z",
    transform: "translate(-113.63 -75.033)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M185.519,144.485l-3.41,4.759h6.819Z",
    transform: "translate(-113.938 -74.692)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M189.31,143.036l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-114.207 -74.638)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M199.92,144.485l-3.41,4.759h6.819Z",
    transform: "translate(-114.476 -74.692)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M218.35,153.089h-8.109l4.055,5.66Z",
    transform: "translate(-114.989 -75.014)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M175.495,152.566h-8.83l4.415,6.164Z",
    transform: "translate(-113.361 -74.994)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M159.463,159.766h8.831l-4.416-6.164Z",
    transform: "translate(-113.092 -75.033)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M152.263,152.566l4.415,6.164,4.416-6.164Z",
    transform: "translate(-112.824 -74.994)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M149.478,153.6l-4.416,6.164h8.83Z",
    transform: "translate(-112.555 -75.033)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M142.291,158.749l4.055-5.66h-8.109Z",
    transform: "translate(-112.3 -75.014)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M130.661,159.765h8.83l-4.415-6.165Z",
    transform: "translate(-112.017 -75.033)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M131.946,153.089h-8.109l4.055,5.66Z",
    transform: "translate(-111.762 -75.014)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M116.261,159.766h8.83l-4.416-6.164Z",
    transform: "translate(-111.479 -75.033)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M113.49,158.749l4.055-5.66h-8.109Z",
    transform: "translate(-111.224 -75.014)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M113.515,144.485l-3.41,4.759h6.819Z",
    transform: "translate(-111.249 -74.692)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M124.125,143.036h-6.819l3.409,4.759Z",
    transform: "translate(-111.518 -74.638)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M128.092,144.73l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-111.787 -74.692)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M131.707,143.036l3.41,4.759,3.409-4.759Z",
    transform: "translate(-112.056 -74.638)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M142.316,144.485l-3.41,4.759h6.819Z",
    transform: "translate(-112.325 -74.692)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M146.108,143.036l3.409,4.759,3.41-4.759Z",
    transform: "translate(-112.594 -74.638)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M156.678,143.548l-4.415,6.165h8.83Z",
    transform: "translate(-112.824 -74.657)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M167.948,143.036h-8.11l4.056,5.661Z",
    transform: "translate(-113.106 -74.638)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M170.756,144.017l-4.093,5.714h8.186Z",
    transform: "translate(-113.361 -74.675)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M181.728,143.036h-6.819l3.409,4.759Z",
    transform: "translate(-113.669 -74.638)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M210.529,143.036h-6.819l3.409,4.759Z",
    transform: "translate(-114.745 -74.638)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M214.5,144.73l-.176-.245-3.409,4.759h6.819Z",
    transform: "translate(-115.014 -74.692)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M177.565,133.795l-4.415,6.164h8.83Z",
    transform: "translate(-113.604 -74.293)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M170.379,138.943l4.055-5.66h-8.109Z",
    transform: "translate(-113.349 -74.274)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M163.165,133.795l-4.415,6.164h8.829Z",
    transform: "translate(-113.066 -74.293)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M155.979,138.943l4.055-5.66h-8.109Z",
    transform: "translate(-112.811 -74.274)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M144.349,139.959h8.83l-4.416-6.165Z",
    transform: "translate(-112.528 -74.293)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M156,124.678l-3.41,4.759h6.819Z",
    transform: "translate(-112.836 -73.953)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M159.795,123.229l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-113.105 -73.899)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M170.4,124.678l-3.41,4.759h6.819Z",
    transform: "translate(-113.374 -73.953)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M188.835,133.282h-8.109l4.055,5.66Z",
    transform: "translate(-113.886 -74.274)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M145.979,132.759h-8.83l4.415,6.164Z",
    transform: "translate(-112.259 -74.255)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M129.948,139.959h8.831l-4.416-6.164Z",
    transform: "translate(-111.99 -74.293)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M122.747,132.759l4.415,6.164,4.416-6.164Z",
    transform: "translate(-111.721 -74.255)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M119.963,133.795l-4.416,6.164h8.83Z",
    transform: "translate(-111.452 -74.293)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M112.776,138.943l4.055-5.66h-8.109Z",
    transform: "translate(-111.198 -74.274)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M112.8,124.678l-3.41,4.759h6.819Z",
    transform: "translate(-111.223 -73.953)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M116.592,123.229,120,127.989l3.41-4.759Z",
    transform: "translate(-111.492 -73.899)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M127.163,123.741l-4.415,6.165h8.83Z",
    transform: "translate(-111.721 -73.918)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M138.432,123.229h-8.11l4.056,5.661Z",
    transform: "translate(-112.004 -73.899)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M141.241,124.21l-4.093,5.714h8.186Z",
    transform: "translate(-112.259 -73.935)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M152.212,123.229h-6.819l3.409,4.759Z",
    transform: "translate(-112.567 -73.899)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M181.014,123.229H174.2l3.409,4.759Z",
    transform: "translate(-113.643 -73.899)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M184.981,124.924l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-113.912 -73.953)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M214.835,113.262l-4.415,6.164h8.83Z",
    transform: "translate(-114.995 -73.526)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M207.649,118.41l4.055-5.66h-8.109Z",
    transform: "translate(-114.74 -73.507)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M200.434,113.262l-4.415,6.164h8.829Z",
    transform: "translate(-114.458 -73.526)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M193.248,118.41l4.055-5.66h-8.109Z",
    transform: "translate(-114.203 -73.507)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M181.618,119.426h8.83l-4.416-6.165Z",
    transform: "translate(-113.92 -73.526)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M193.273,104.146l-3.41,4.759h6.819Z",
    transform: "translate(-114.228 -73.186)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M197.064,102.7l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-114.497 -73.132)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M207.674,104.146l-3.41,4.759h6.819Z",
    transform: "translate(-114.766 -73.186)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M183.249,112.226h-8.83l4.415,6.164Z",
    transform: "translate(-113.651 -73.488)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M167.217,119.426h8.831l-4.416-6.164Z",
    transform: "translate(-113.382 -73.526)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M160.017,112.226l4.415,6.164,4.416-6.164Z",
    transform: "translate(-113.113 -73.488)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M157.232,113.262l-4.416,6.164h8.83Z",
    transform: "translate(-112.844 -73.526)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M150.046,118.41l4.055-5.66h-8.109Z",
    transform: "translate(-112.589 -73.507)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M138.415,119.426h8.83l-4.415-6.165Z",
    transform: "translate(-112.306 -73.526)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M139.7,112.749H131.59l4.055,5.66Z",
    transform: "translate(-112.052 -73.507)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M124.015,119.426h8.83l-4.416-6.164Z",
    transform: "translate(-111.769 -73.526)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M121.244,118.41l4.055-5.66h-8.109Z",
    transform: "translate(-111.514 -73.507)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M121.269,104.146l-3.41,4.759h6.819Z",
    transform: "translate(-111.539 -73.186)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M131.878,102.7H125.06l3.409,4.759Z",
    transform: "translate(-111.808 -73.132)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M135.846,104.391l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-112.077 -73.186)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M139.461,102.7l3.41,4.759,3.409-4.759Z",
    transform: "translate(-112.346 -73.132)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M150.071,104.146l-3.41,4.759h6.819Z",
    transform: "translate(-112.614 -73.186)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M153.862,102.7l3.409,4.759,3.41-4.759Z",
    transform: "translate(-112.883 -73.132)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M164.432,103.209l-4.415,6.165h8.83Z",
    transform: "translate(-113.113 -73.151)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M175.7,102.7h-8.11l4.056,5.661Z",
    transform: "translate(-113.396 -73.132)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M178.51,103.677l-4.093,5.714H182.6Z",
    transform: "translate(-113.651 -73.169)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M189.482,102.7h-6.818l3.409,4.759Z",
    transform: "translate(-113.959 -73.132)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M218.283,102.7h-6.819l3.409,4.759Z",
    transform: "translate(-115.034 -73.132)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M200.312,93.327,195.9,99.491h8.83Z",
    transform: "translate(-114.453 -72.782)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M193.126,98.475l4.055-5.66h-8.109Z",
    transform: "translate(-114.198 -72.763)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M185.912,93.327,181.5,99.491h8.829Z",
    transform: "translate(-113.915 -72.782)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M178.725,98.475l4.055-5.66h-8.109Z",
    transform: "translate(-113.66 -72.763)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M167.1,99.491h8.83l-4.416-6.165Z",
    transform: "translate(-113.377 -72.782)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M178.75,84.211l-3.41,4.759h6.819Z",
    transform: "translate(-113.685 -72.442)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M182.541,82.762l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-113.954 -72.387)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M193.151,84.211l-3.41,4.759h6.819Z",
    transform: "translate(-114.223 -72.442)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M211.582,92.814h-8.109l4.055,5.66Z",
    transform: "translate(-114.736 -72.763)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M168.726,92.291H159.9l4.415,6.164Z",
    transform: "translate(-113.109 -72.743)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M152.694,99.491h8.831l-4.416-6.164Z",
    transform: "translate(-112.84 -72.782)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M145.494,92.291l4.415,6.164,4.416-6.164Z",
    transform: "translate(-112.571 -72.743)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M142.71,93.327l-4.416,6.164h8.83Z",
    transform: "translate(-112.302 -72.782)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M135.523,98.475l4.055-5.66h-8.109Z",
    transform: "translate(-112.047 -72.763)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M123.893,99.491h8.83l-4.415-6.165Z",
    transform: "translate(-111.764 -72.782)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M125.177,92.814h-8.109l4.055,5.66Z",
    transform: "translate(-111.509 -72.763)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M109.492,99.491h8.83l-4.416-6.164Z",
    transform: "translate(-111.226 -72.782)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M117.356,82.762h-6.818l3.409,4.759Z",
    transform: "translate(-111.265 -72.387)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M121.323,84.456l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-111.534 -72.442)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M124.938,82.762l3.41,4.759,3.409-4.759Z",
    transform: "translate(-111.803 -72.387)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M135.548,84.211l-3.41,4.759h6.819Z",
    transform: "translate(-112.072 -72.442)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M139.339,82.762l3.409,4.759,3.41-4.759Z",
    transform: "translate(-112.341 -72.387)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M149.909,83.274l-4.415,6.165h8.83Z",
    transform: "translate(-112.571 -72.407)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M161.179,82.762h-8.11l4.056,5.661Z",
    transform: "translate(-112.854 -72.387)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M163.987,83.742l-4.093,5.714h8.186Z",
    transform: "translate(-113.109 -72.424)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M174.959,82.762H168.14l3.409,4.759Z",
    transform: "translate(-113.417 -72.387)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M203.76,82.762h-6.818l3.409,4.759Z",
    transform: "translate(-114.492 -72.387)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M207.728,84.456l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-114.761 -72.442)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M217.11,74.066l-4.415,6.164h8.829Z",
    transform: "translate(-115.08 -72.063)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M209.923,79.214l4.055-5.66h-8.109Z",
    transform: "translate(-114.825 -72.044)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M198.293,80.23h8.83l-4.416-6.165Z",
    transform: "translate(-114.543 -72.063)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M209.948,64.949l-3.41,4.759h6.819Z",
    transform: "translate(-114.85 -71.722)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M213.739,63.5l3.41,4.759.176-.245,3.233-4.514Z",
    transform: "translate(-115.119 -71.668)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M199.924,73.03h-8.83l4.415,6.164Z",
    transform: "translate(-114.274 -72.024)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M183.892,80.23h8.831l-4.416-6.164Z",
    transform: "translate(-114.005 -72.063)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M176.692,73.03l4.415,6.164,4.416-6.164Z",
    transform: "translate(-113.736 -72.024)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M173.908,74.066l-4.416,6.164h8.83Z",
    transform: "translate(-113.467 -72.063)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M166.721,79.214l4.055-5.66h-8.109Z",
    transform: "translate(-113.212 -72.044)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M155.091,80.23h8.83l-4.415-6.165Z",
    transform: "translate(-112.929 -72.063)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M156.375,73.553h-8.109l4.055,5.66Z",
    transform: "translate(-112.674 -72.044)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M140.69,80.23h8.83l-4.416-6.164Z",
    transform: "translate(-112.391 -72.063)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M137.919,79.214l4.055-5.66h-8.109Z",
    transform: "translate(-112.137 -72.044)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M137.944,64.949l-3.41,4.759h6.819Z",
    transform: "translate(-112.162 -71.722)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M148.554,63.5h-6.819l3.409,4.759Z",
    transform: "translate(-112.43 -71.668)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M152.521,65.195l-.176-.245-3.409,4.759h6.818Z",
    transform: "translate(-112.699 -71.722)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M156.136,63.5l3.41,4.759,3.409-4.759Z",
    transform: "translate(-112.968 -71.668)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M166.746,64.949l-3.41,4.759h6.819Z",
    transform: "translate(-113.237 -71.722)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M170.537,63.5l3.409,4.759,3.41-4.759Z",
    transform: "translate(-113.506 -71.668)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M181.107,64.012l-4.415,6.165h8.83Z",
    transform: "translate(-113.736 -71.687)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M192.377,63.5h-8.11l4.056,5.661Z",
    transform: "translate(-114.019 -71.668)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M195.185,64.481,191.092,70.2h8.186Z",
    transform: "translate(-114.274 -71.705)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M206.157,63.5h-6.819l3.409,4.759Z",
    transform: "translate(-114.582 -71.668)",
    fill: "#3ab3a8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(16.563 1.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M136.715,94.957l-3.987,6.308H140.7Z",
    transform: "translate(-31.748 -3.155)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M129.564,100.238l3.661-5.793H125.9Z",
    transform: "translate(-30.856 -3.147)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M122.315,94.957l-3.987,6.308H126.3Z",
    transform: "translate(-29.866 -3.155)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M115.163,100.238l3.661-5.793H111.5Z",
    transform: "translate(-28.974 -3.147)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M103.927,101.266H111.9l-3.987-6.309Z",
    transform: "translate(-27.983 -3.155)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M115.251,85.841l-3.079,4.871h6.158Z",
    transform: "translate(-29.061 -3.02)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M119.373,84.392l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-30.002 -2.998)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M129.651,85.841l-3.079,4.871h6.158Z",
    transform: "translate(-30.944 -3.02)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M104.7,93.922H96.727l3.987,6.308Z",
    transform: "translate(-27.042 -3.139)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M89.526,101.266H97.5l-3.987-6.308Z",
    transform: "translate(-26.101 -3.155)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M82.325,93.922l3.987,6.308L90.3,93.922Z",
    transform: "translate(-25.16 -3.139)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M79.112,94.957l-3.987,6.308H83.1Z",
    transform: "translate(-24.218 -3.155)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M71.961,100.238l3.661-5.793H68.3Z",
    transform: "translate(-23.326 -3.147)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M60.724,101.266H68.7l-3.987-6.309Z",
    transform: "translate(-22.336 -3.155)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M61.222,94.445H53.9l3.661,5.793Z",
    transform: "translate(-21.444 -3.147)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M46.324,101.266H54.3L50.31,94.958Z",
    transform: "translate(-20.453 -3.155)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M43.159,100.238l3.661-5.793H39.5Z",
    transform: "translate(-19.561 -3.147)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M43.247,85.841l-3.079,4.871h6.158Z",
    transform: "translate(-19.649 -3.02)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M53.526,84.392H47.369l3.078,4.871Z",
    transform: "translate(-20.59 -2.998)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M57.807,86.092l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-21.531 -3.02)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M61.77,84.392l3.079,4.871,3.078-4.871Z",
    transform: "translate(-22.472 -2.998)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M72.048,85.841l-3.079,4.871h6.158Z",
    transform: "translate(-23.414 -3.02)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M76.171,84.392l3.078,4.871,3.079-4.871Z",
    transform: "translate(-24.355 -2.998)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M86.312,84.9l-3.987,6.309H90.3Z",
    transform: "translate(-25.16 -3.006)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M97.224,84.392H89.9l3.662,5.794Z",
    transform: "translate(-26.15 -2.998)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M100.422,85.373l-3.7,5.848h7.392Z",
    transform: "translate(-27.042 -3.013)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M111.129,84.392h-6.157l3.078,4.871Z",
    transform: "translate(-28.12 -2.998)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M139.93,84.392h-6.157l3.078,4.871Z",
    transform: "translate(-31.885 -2.998)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M144.211,86.092l-.159-.251-3.078,4.871h6.157Z",
    transform: "translate(-32.826 -3.02)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M130.281,118.808l3.661-5.793H126.62Z",
    transform: "translate(-30.95 -3.423)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M119.045,119.836h7.974l-3.987-6.309Z",
    transform: "translate(-29.96 -3.43)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M130.369,104.411l-3.079,4.871h6.158Z",
    transform: "translate(-31.037 -3.295)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M134.49,102.962l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-31.979 -3.274)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M119.819,112.492h-7.974l3.987,6.308Z",
    transform: "translate(-29.018 -3.415)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M104.644,119.836h7.975l-3.987-6.308Z",
    transform: "translate(-28.077 -3.43)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M97.443,112.492l3.987,6.308,3.987-6.308Z",
    transform: "translate(-27.136 -3.415)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M94.23,113.528l-3.987,6.308h7.974Z",
    transform: "translate(-26.195 -3.43)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M87.079,118.808l3.661-5.793H83.417Z",
    transform: "translate(-25.302 -3.423)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M75.842,119.836h7.974l-3.987-6.309Z",
    transform: "translate(-24.312 -3.43)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M76.339,113.015H69.017l3.661,5.793Z",
    transform: "translate(-23.42 -3.423)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M61.441,119.836h7.974l-3.987-6.308Z",
    transform: "translate(-22.43 -3.43)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M58.277,118.808l3.661-5.793H54.616Z",
    transform: "translate(-21.537 -3.423)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M58.365,104.411l-3.079,4.871h6.158Z",
    transform: "translate(-21.625 -3.295)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M68.643,102.962H62.486l3.078,4.871Z",
    transform: "translate(-22.566 -3.274)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M72.924,104.663l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-23.507 -3.295)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M76.887,102.962l3.079,4.871,3.078-4.871Z",
    transform: "translate(-24.449 -3.274)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M87.166,104.411l-3.079,4.871h6.158Z",
    transform: "translate(-25.39 -3.295)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M91.288,102.962l3.078,4.871,3.079-4.871Z",
    transform: "translate(-26.331 -3.274)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M101.43,103.474l-3.986,6.309h7.974Z",
    transform: "translate(-27.136 -3.281)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M112.342,102.962h-7.324l3.662,5.794Z",
    transform: "translate(-28.126 -3.274)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M115.539,103.943l-3.7,5.848h7.392Z",
    transform: "translate(-29.018 -3.288)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M126.247,102.962H120.09l3.078,4.871Z",
    transform: "translate(-30.096 -3.274)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M134.938,75.275l-3.987,6.308h7.974Z",
    transform: "translate(-31.516 -2.863)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M127.787,80.556l3.661-5.793h-7.323Z",
    transform: "translate(-30.624 -2.855)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M120.538,75.275l-3.987,6.308h7.973Z",
    transform: "translate(-29.634 -2.863)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M113.386,80.556l3.661-5.793h-7.323Z",
    transform: "translate(-28.741 -2.855)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M102.15,81.584h7.974l-3.987-6.309Z",
    transform: "translate(-27.751 -2.863)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M145.4,66.121l-3.079,4.871h6.158Z",
    transform: "translate(-33.003 -2.727)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M149.525,64.672l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-33.944 -2.705)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M159.8,66.121l-3.079,4.871h6.158Z",
    transform: "translate(-34.885 -2.727)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M145.849,74.763h-7.323l3.661,5.793Z",
    transform: "translate(-32.506 -2.855)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M102.924,74.24H94.95l3.987,6.308Z",
    transform: "translate(-26.81 -2.847)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M87.748,81.584h7.975l-3.987-6.308Z",
    transform: "translate(-25.868 -2.863)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M80.548,74.24l3.987,6.308,3.987-6.308Z",
    transform: "translate(-24.927 -2.847)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M77.335,75.275l-3.987,6.308h7.974Z",
    transform: "translate(-23.986 -2.863)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M70.184,80.556l3.661-5.793H66.522Z",
    transform: "translate(-23.094 -2.855)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M58.947,81.584h7.974l-3.987-6.309Z",
    transform: "translate(-22.103 -2.863)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M59.444,74.763H52.122l3.661,5.793Z",
    transform: "translate(-21.211 -2.855)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M44.546,81.584H52.52l-3.987-6.308Z",
    transform: "translate(-20.221 -2.863)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M41.382,80.556l3.661-5.793H37.72Z",
    transform: "translate(-19.329 -2.855)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M73.4,66.121,70.32,70.991h6.158Z",
    transform: "translate(-23.59 -2.727)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M83.678,64.672H77.521L80.6,69.542Z",
    transform: "translate(-24.531 -2.705)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M87.959,66.372l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-25.473 -2.727)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M91.922,64.672,95,69.542l3.078-4.871Z",
    transform: "translate(-26.414 -2.705)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M102.2,66.121l-3.079,4.871h6.158Z",
    transform: "translate(-27.355 -2.727)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M106.323,64.672l3.078,4.871,3.079-4.871Z",
    transform: "translate(-28.297 -2.705)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M116.465,65.184l-3.987,6.309h7.974Z",
    transform: "translate(-29.101 -2.713)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M127.376,64.672h-7.324l3.662,5.794Z",
    transform: "translate(-30.091 -2.705)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M130.574,65.652l-3.7,5.848h7.392Z",
    transform: "translate(-30.984 -2.72)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M141.281,64.672h-6.157l3.078,4.871Z",
    transform: "translate(-32.061 -2.705)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M165.7,56.459l-3.987,6.308h7.974Z",
    transform: "translate(-35.538 -2.584)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M158.552,61.739l3.661-5.793h-7.323Z",
    transform: "translate(-34.645 -2.576)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M151.3,56.459l-3.986,6.308h7.973Z",
    transform: "translate(-33.655 -2.584)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M144.152,61.739l3.661-5.793H140.49Z",
    transform: "translate(-32.763 -2.576)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M132.915,62.767h7.974L136.9,56.458Z",
    transform: "translate(-31.773 -2.584)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M144.239,47.343l-3.079,4.871h6.158Z",
    transform: "translate(-32.85 -2.448)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M148.361,45.893l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-33.792 -2.427)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M158.64,47.343l-3.079,4.871h6.158Z",
    transform: "translate(-34.733 -2.448)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M176.614,55.946h-7.323l3.661,5.793Z",
    transform: "translate(-36.528 -2.576)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M133.689,55.423h-7.974l3.987,6.308Z",
    transform: "translate(-30.831 -2.568)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M118.514,62.767h7.975L122.5,56.459Z",
    transform: "translate(-29.89 -2.584)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M111.314,55.423l3.986,6.308,3.987-6.308Z",
    transform: "translate(-28.949 -2.568)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M108.1,56.459l-3.987,6.308h7.974Z",
    transform: "translate(-28.008 -2.584)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M100.949,61.739l3.661-5.793H97.287Z",
    transform: "translate(-27.115 -2.576)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M89.712,62.767h7.974L93.7,56.458Z",
    transform: "translate(-26.125 -2.584)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M90.21,55.946H82.887l3.661,5.793Z",
    transform: "translate(-25.233 -2.576)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M75.312,62.767h7.974L79.3,56.459Z",
    transform: "translate(-24.243 -2.584)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M72.147,61.739l3.661-5.793H68.486Z",
    transform: "translate(-23.35 -2.576)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M72.235,47.343l-3.079,4.871h6.158Z",
    transform: "translate(-23.438 -2.448)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M82.514,45.893H76.357l3.078,4.871Z",
    transform: "translate(-24.379 -2.427)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M86.795,47.594l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-25.321 -2.448)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M90.758,45.893l3.079,4.871,3.078-4.871Z",
    transform: "translate(-26.262 -2.427)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M101.036,47.343l-3.079,4.871h6.158Z",
    transform: "translate(-27.203 -2.448)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M105.159,45.893l3.078,4.871,3.079-4.871Z",
    transform: "translate(-28.144 -2.427)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M115.3,46.405l-3.987,6.309h7.974Z",
    transform: "translate(-28.949 -2.434)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M126.212,45.893h-7.324l3.662,5.794Z",
    transform: "translate(-29.939 -2.427)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M129.41,46.874l-3.7,5.848h7.392Z",
    transform: "translate(-30.831 -2.441)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M140.117,45.893H133.96l3.078,4.871Z",
    transform: "translate(-31.909 -2.427)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M168.919,45.893h-6.157l3.078,4.871Z",
    transform: "translate(-35.674 -2.427)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M173.2,47.594l-.159-.251-3.078,4.871h6.157Z",
    transform: "translate(-36.615 -2.448)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M196.56,42.475l3.661-5.793H192.9Z",
    transform: "translate(-39.614 -2.29)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M185.323,43.5H193.3l-3.987-6.309Z",
    transform: "translate(-38.624 -2.298)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M196.647,28.079l-3.079,4.871h6.158Z",
    transform: "translate(-39.701 -2.162)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M186.1,36.159h-7.974l3.986,6.308Z",
    transform: "translate(-37.682 -2.282)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M170.922,43.5H178.9L174.91,37.2Z",
    transform: "translate(-36.741 -2.298)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M163.722,36.159l3.986,6.308,3.987-6.308Z",
    transform: "translate(-35.8 -2.282)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M160.509,37.195,156.522,43.5H164.5Z",
    transform: "translate(-34.859 -2.298)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M153.357,42.475l3.661-5.793H149.7Z",
    transform: "translate(-33.966 -2.29)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M142.121,43.5h7.974l-3.987-6.309Z",
    transform: "translate(-32.976 -2.298)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M142.618,36.682H135.3l3.661,5.793Z",
    transform: "translate(-32.084 -2.29)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M127.72,43.5h7.974L131.706,37.2Z",
    transform: "translate(-31.094 -2.298)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M124.556,42.475l3.661-5.793h-7.323Z",
    transform: "translate(-30.201 -2.29)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M124.643,28.079l-3.079,4.871h6.158Z",
    transform: "translate(-30.289 -2.162)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M134.922,26.629h-6.157l3.078,4.871Z",
    transform: "translate(-31.23 -2.141)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M139.2,28.33l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-32.171 -2.162)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M143.166,26.629l3.079,4.871,3.078-4.871Z",
    transform: "translate(-33.113 -2.141)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M153.445,28.079l-3.079,4.871h6.158Z",
    transform: "translate(-34.054 -2.162)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M157.567,26.629l3.078,4.871,3.079-4.871Z",
    transform: "translate(-34.995 -2.141)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M167.709,27.141l-3.987,6.309H171.7Z",
    transform: "translate(-35.8 -2.148)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M178.62,26.629H171.3l3.662,5.794Z",
    transform: "translate(-36.79 -2.141)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M181.818,27.61l-3.7,5.848h7.392Z",
    transform: "translate(-37.682 -2.155)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M192.525,26.629h-6.157l3.078,4.871Z",
    transform: "translate(-38.76 -2.141)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M118.242,132.428l-3.986,6.308h7.974Z",
    transform: "translate(-29.334 -3.711)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M111.091,137.709l3.661-5.793H107.43Z",
    transform: "translate(-28.441 -3.703)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M103.842,132.428l-3.986,6.308h7.973Z",
    transform: "translate(-27.451 -3.711)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M96.691,137.709l3.661-5.793H93.029Z",
    transform: "translate(-26.559 -3.703)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M85.454,138.737h7.974l-3.987-6.309Z",
    transform: "translate(-25.568 -3.711)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M96.778,123.312,93.7,128.183h6.158Z",
    transform: "translate(-26.646 -3.576)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M100.9,121.863l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-27.588 -3.554)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M111.179,123.312l-3.079,4.871h6.158Z",
    transform: "translate(-28.529 -3.576)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M129.153,131.916h-7.323l3.661,5.793Z",
    transform: "translate(-30.324 -3.703)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M86.228,131.393H78.254l3.987,6.308Z",
    transform: "translate(-24.627 -3.696)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M71.053,138.737h7.975l-3.987-6.308Z",
    transform: "translate(-23.686 -3.711)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M63.853,131.393l3.987,6.308,3.987-6.308Z",
    transform: "translate(-22.745 -3.696)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M60.64,132.428l-3.987,6.308h7.974Z",
    transform: "translate(-21.803 -3.711)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M53.488,137.709l3.661-5.793H49.826Z",
    transform: "translate(-20.911 -3.703)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M42.251,138.737h7.974l-3.987-6.309Z",
    transform: "translate(-19.921 -3.711)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M42.749,131.916H35.426l3.661,5.793Z",
    transform: "translate(-19.029 -3.703)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M27.851,138.737h7.974l-3.987-6.308Z",
    transform: "translate(-18.039 -3.711)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M24.686,137.709l3.661-5.793H21.025Z",
    transform: "translate(-17.146 -3.703)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M24.774,123.312l-3.079,4.871h6.158Z",
    transform: "translate(-17.234 -3.576)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M35.053,121.863H28.9l3.078,4.871Z",
    transform: "translate(-18.175 -3.554)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M39.334,123.563l-.159-.251L36.1,128.183h6.156Z",
    transform: "translate(-19.116 -3.576)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M43.3,121.863l3.079,4.871,3.078-4.871Z",
    transform: "translate(-20.058 -3.554)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M53.575,123.312,50.5,128.183h6.158Z",
    transform: "translate(-20.999 -3.576)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M57.7,121.863l3.078,4.871,3.079-4.871Z",
    transform: "translate(-21.94 -3.554)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M67.84,122.375l-3.987,6.309h7.974Z",
    transform: "translate(-22.745 -3.562)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M78.751,121.863H71.427l3.662,5.794Z",
    transform: "translate(-23.735 -3.554)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M81.949,122.844l-3.7,5.848h7.392Z",
    transform: "translate(-24.627 -3.569)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M92.656,121.863H86.5l3.078,4.871Z",
    transform: "translate(-25.705 -3.554)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M121.458,121.863H115.3l3.078,4.871Z",
    transform: "translate(-29.47 -3.554)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M125.739,123.563l-.159-.251-3.078,4.871h6.157Z",
    transform: "translate(-30.411 -3.576)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M194.123,23.4l3.661-5.793h-7.323Z",
    transform: "translate(-39.295 -2.007)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M186.874,18.116l-3.986,6.308h7.973Z",
    transform: "translate(-38.305 -2.015)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M179.723,23.4l3.661-5.793h-7.323Z",
    transform: "translate(-37.413 -2.007)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M168.486,24.425h7.974l-3.987-6.309Z",
    transform: "translate(-36.423 -2.015)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M179.81,9l-3.079,4.871h6.158Z",
    transform: "translate(-37.5 -1.879)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M183.932,7.551l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-38.442 -1.858)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M194.211,9l-3.079,4.871h6.158Z",
    transform: "translate(-39.383 -1.879)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M169.26,17.081h-7.974l3.986,6.308Z",
    transform: "translate(-35.481 -1.999)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M154.085,24.425h7.975l-3.987-6.308Z",
    transform: "translate(-34.54 -2.015)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M146.885,17.081l3.986,6.308,3.987-6.308Z",
    transform: "translate(-33.599 -1.999)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M143.672,18.116l-3.987,6.308h7.974Z",
    transform: "translate(-32.658 -2.015)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M136.52,23.4l3.661-5.793h-7.323Z",
    transform: "translate(-31.765 -2.007)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M125.283,24.425h7.974l-3.987-6.309Z",
    transform: "translate(-30.775 -2.015)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M125.781,17.6h-7.323l3.661,5.793Z",
    transform: "translate(-29.883 -2.007)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M110.883,24.425h7.974l-3.987-6.308Z",
    transform: "translate(-28.893 -2.015)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M107.718,23.4,111.38,17.6h-7.323Z",
    transform: "translate(-28 -2.007)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M107.806,9l-3.079,4.871h6.158Z",
    transform: "translate(-28.088 -1.879)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M118.085,7.551h-6.157l3.078,4.871Z",
    transform: "translate(-29.029 -1.858)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M122.366,9.251,122.207,9l-3.078,4.871h6.156Z",
    transform: "translate(-29.97 -1.879)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M126.329,7.551l3.079,4.871,3.078-4.871Z",
    transform: "translate(-30.912 -1.858)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M136.607,9l-3.079,4.871h6.158Z",
    transform: "translate(-31.853 -1.879)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M140.73,7.551l3.078,4.871,3.079-4.871Z",
    transform: "translate(-32.794 -1.858)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M150.871,8.063l-3.987,6.309h7.974Z",
    transform: "translate(-33.599 -1.865)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M161.783,7.551h-7.324l3.662,5.794Z",
    transform: "translate(-34.589 -1.858)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M164.981,8.532l-3.7,5.848h7.392Z",
    transform: "translate(-35.481 -1.872)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M175.688,7.551h-6.157l3.078,4.871Z",
    transform: "translate(-36.559 -1.858)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M204.49,7.551h-6.157l3.078,4.871Z",
    transform: "translate(-40.324 -1.858)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M208.77,9.251,208.611,9l-3.078,4.871h6.157Z",
    transform: "translate(-41.265 -1.879)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M194.192.251,194.033,0l-3.078,4.871h6.157Z",
    transform: "translate(-39.36 -1.746)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M116.566,151.06l-3.987,6.308h7.974Z",
    transform: "translate(-29.114 -3.987)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M109.414,156.341l3.661-5.793h-7.323Z",
    transform: "translate(-28.222 -3.98)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M102.165,151.06l-3.987,6.308h7.973Z",
    transform: "translate(-27.232 -3.987)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M95.014,156.341l3.661-5.793H91.352Z",
    transform: "translate(-26.34 -3.98)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M83.777,157.368h7.974l-3.987-6.309Z",
    transform: "translate(-25.349 -3.987)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M95.1,141.944l-3.079,4.871H98.18Z",
    transform: "translate(-26.427 -3.852)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M99.223,140.495l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-27.368 -3.831)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M109.5,141.944l-3.079,4.871h6.158Z",
    transform: "translate(-28.31 -3.852)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M127.477,150.547h-7.323l3.661,5.793Z",
    transform: "translate(-30.104 -3.98)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M84.551,150.024H76.577l3.987,6.308Z",
    transform: "translate(-24.408 -3.972)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M69.376,157.368h7.975l-3.987-6.308Z",
    transform: "translate(-23.467 -3.987)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M62.176,150.024l3.987,6.308,3.987-6.308Z",
    transform: "translate(-22.526 -3.972)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M58.963,151.06l-3.987,6.308h7.974Z",
    transform: "translate(-21.584 -3.987)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M51.811,156.341l3.661-5.793H48.15Z",
    transform: "translate(-20.692 -3.98)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M40.574,157.368h7.974l-3.987-6.309Z",
    transform: "translate(-19.702 -3.987)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M41.072,150.547H33.749l3.661,5.793Z",
    transform: "translate(-18.81 -3.98)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M26.174,157.368h7.974l-3.987-6.308Z",
    transform: "translate(-17.819 -3.987)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M23.01,156.341l3.661-5.793H19.348Z",
    transform: "translate(-16.927 -3.98)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M23.1,141.944l-3.079,4.871h6.158Z",
    transform: "translate(-17.015 -3.852)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M33.376,140.495H27.219l3.078,4.871Z",
    transform: "translate(-17.956 -3.831)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M37.657,142.195l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-18.897 -3.852)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M41.62,140.495l3.079,4.871,3.078-4.871Z",
    transform: "translate(-19.838 -3.831)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M51.9,141.944l-3.079,4.871h6.158Z",
    transform: "translate(-20.78 -3.852)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M56.021,140.495l3.078,4.871,3.079-4.871Z",
    transform: "translate(-21.721 -3.831)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M66.163,141.007l-3.987,6.309H70.15Z",
    transform: "translate(-22.526 -3.838)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M77.074,140.495H69.75l3.662,5.794Z",
    transform: "translate(-23.516 -3.831)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M80.272,141.475l-3.7,5.848h7.392Z",
    transform: "translate(-24.408 -3.845)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M90.979,140.495H84.822l3.078,4.871Z",
    transform: "translate(-25.486 -3.831)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M119.781,140.495h-6.157l3.078,4.871Z",
    transform: "translate(-29.251 -3.831)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M124.062,142.195l-.159-.251-3.078,4.871h6.157Z",
    transform: "translate(-30.192 -3.852)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M97.218,169.906l-3.986,6.308h7.974Z",
    transform: "translate(-26.585 -4.267)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M90.067,175.187l3.661-5.793H86.405Z",
    transform: "translate(-25.693 -4.26)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M82.818,169.906l-3.987,6.308H86.8Z",
    transform: "translate(-24.703 -4.267)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M75.666,175.187l3.661-5.793H72Z",
    transform: "translate(-23.81 -4.26)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M64.429,176.215H72.4l-3.987-6.309Z",
    transform: "translate(-22.82 -4.267)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M75.754,160.79l-3.079,4.871h6.158Z",
    transform: "translate(-23.898 -4.132)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M79.875,159.341l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-24.839 -4.11)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M90.154,160.79l-3.079,4.871h6.158Z",
    transform: "translate(-25.78 -4.132)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M108.129,169.394h-7.323l3.661,5.793Z",
    transform: "translate(-27.575 -4.259)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M65.2,168.871H57.23l3.987,6.308Z",
    transform: "translate(-21.879 -4.252)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M50.028,176.215H58l-3.987-6.308Z",
    transform: "translate(-20.938 -4.267)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M42.828,168.871l3.987,6.308,3.987-6.308Z",
    transform: "translate(-19.996 -4.252)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M39.615,169.906l-3.987,6.308H43.6Z",
    transform: "translate(-19.055 -4.267)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M32.464,175.187l3.661-5.793H28.8Z",
    transform: "translate(-18.163 -4.26)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M21.227,176.215H29.2l-3.987-6.309Z",
    transform: "translate(-17.173 -4.267)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M21.724,169.394H14.4l3.661,5.793Z",
    transform: "translate(-16.28 -4.259)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M18.309,161.041l-.159-.251-3.078,4.871h6.156Z",
    transform: "translate(-16.368 -4.132)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M22.272,159.341l3.079,4.871,3.078-4.871Z",
    transform: "translate(-17.309 -4.11)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M32.551,160.79l-3.079,4.871H35.63Z",
    transform: "translate(-18.25 -4.132)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M36.673,159.341l3.078,4.871,3.079-4.871Z",
    transform: "translate(-19.192 -4.11)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M46.815,159.853l-3.987,6.309H50.8Z",
    transform: "translate(-19.996 -4.118)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M57.727,159.341H50.4l3.662,5.794Z",
    transform: "translate(-20.987 -4.11)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M60.924,160.322l-3.7,5.848h7.392Z",
    transform: "translate(-21.879 -4.125)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M71.632,159.341H65.474l3.078,4.871Z",
    transform: "translate(-22.957 -4.11)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M100.433,159.341H94.276l3.078,4.871Z",
    transform: "translate(-26.722 -4.11)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M104.714,161.041l-.159-.251-3.078,4.871h6.157Z",
    transform: "translate(-27.663 -4.132)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M107.669,189.276l-3.987,6.308h7.974Z",
    transform: "translate(-27.951 -4.555)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M100.518,194.556l3.661-5.793H96.857Z",
    transform: "translate(-27.059 -4.547)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M93.269,189.276l-3.987,6.308h7.973Z",
    transform: "translate(-26.069 -4.555)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M86.118,194.556l3.661-5.793H82.456Z",
    transform: "translate(-25.177 -4.547)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M74.881,195.584h7.974l-3.987-6.309Z",
    transform: "translate(-24.186 -4.555)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M86.205,180.159l-3.079,4.871h6.158Z",
    transform: "translate(-25.264 -4.419)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M90.327,178.71l3.079,4.871.159-.251,2.919-4.619Z",
    transform: "translate(-26.205 -4.398)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M100.606,180.159l-3.079,4.871h6.158Z",
    transform: "translate(-27.147 -4.419)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M118.58,188.763h-7.323l3.661,5.793Z",
    transform: "translate(-28.942 -4.547)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M75.655,188.24H67.681l3.987,6.308Z",
    transform: "translate(-23.245 -4.539)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M60.48,195.584h7.975l-3.987-6.308Z",
    transform: "translate(-22.304 -4.555)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M53.28,188.24l3.987,6.308,3.987-6.308Z",
    transform: "translate(-21.363 -4.539)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M50.067,189.276l-3.987,6.308h7.974Z",
    transform: "translate(-20.421 -4.555)",
    fill: "#3f4055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M42.915,194.556l3.661-5.793H39.253Z",
    transform: "translate(-19.529 -4.547)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M31.678,195.584h7.974l-3.987-6.309Z",
    transform: "translate(-18.539 -4.555)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M32.176,188.763H24.853l3.661,5.793Z",
    transform: "translate(-17.647 -4.547)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M17.278,195.584h7.974l-3.987-6.308Z",
    transform: "translate(-16.656 -4.555)",
    fill: "#f79d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M14.113,194.556l3.661-5.793H10.452Z",
    transform: "translate(-15.764 -4.547)",
    fill: "#71c6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M14.2,180.159l-3.079,4.871H17.28Z",
    transform: "translate(-15.852 -4.419)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M24.48,178.71H18.323l3.078,4.871Z",
    transform: "translate(-16.793 -4.398)",
    fill: "#2071b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M28.761,180.41l-.159-.251-3.078,4.871H31.68Z",
    transform: "translate(-17.734 -4.419)",
    fill: "#dd0840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M32.724,178.71l3.079,4.871,3.078-4.871Z",
    transform: "translate(-18.676 -4.398)",
    fill: "#131b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M43,180.159l-3.079,4.871h6.158Z",
    transform: "translate(-19.617 -4.419)",
    fill: "#2e3054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M47.125,178.71l3.078,4.871,3.079-4.871Z",
    transform: "translate(-20.558 -4.398)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M57.266,179.222l-3.987,6.309h7.974Z",
    transform: "translate(-21.363 -4.405)",
    fill: "#0057a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M68.178,178.71H60.854l3.662,5.794Z",
    transform: "translate(-22.353 -4.398)",
    fill: "#ffd494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M71.376,179.691l-3.7,5.848h7.392Z",
    transform: "translate(-23.245 -4.412)",
    fill: "#ffc164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M82.083,178.71H75.926L79,183.581Z",
    transform: "translate(-24.323 -4.398)",
    fill: "#3ab3a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M110.885,178.71h-6.157l3.078,4.871Z",
    transform: "translate(-28.088 -4.398)",
    fill: "#4780b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M115.165,180.41l-.159-.251-3.078,4.871h6.157Z",
    transform: "translate(-29.029 -4.419)",
    fill: "#3ab3a8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKLogoCathk);
export default __webpack_public_path__ + "static/media/k-logo-cathk.662bcfc34040df553fedbfaf3efd2d3d.svg";
export { ForwardRef as ReactComponent };